import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fiction-2",
  "use": "fiction-2-usage",
  "viewBox": "0 0 32 34",
  "content": "<symbol viewBox=\"0 0 32 34\" id=\"fiction-2\"><path d=\"M23.26 3.21A12.71 12.71 0 0 0 15.63 1a10.67 10.67 0 0 0-5.89 1.56Q5.95 5 5.7 10.76h5.87a6 6 0 0 1 1-3.25A3.64 3.64 0 0 1 15.89 6a3.79 3.79 0 0 1 3.29 1.26 4.77 4.77 0 0 1 .9 2.81 4.22 4.22 0 0 1-1 2.46 5.08 5.08 0 0 1-1.17 1.2 26.65 26.65 0 0 0-4.58 3.68c-.81.95-.88 2.38-1 4.42 0 .14.06.44.56.44h4.57a.49.49 0 0 0 .55-.48 5.55 5.55 0 0 1 .25-1.56A4.83 4.83 0 0 1 20 18.11l1.62-1.12a17.45 17.45 0 0 0 3.13-2.8A7.41 7.41 0 0 0 26.3 9.7a7.47 7.47 0 0 0-3-6.49zm-7.72 22.53a3.54 3.54 0 0 0-3.76 3.54A3.5 3.5 0 0 0 15.33 33a3.48 3.48 0 0 0 3.8-3.49 3.53 3.53 0 0 0-3.59-3.77z\" /><path fill=\"none\" d=\"M0 0h32v34H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fiction-2.svg
// module id = s/or
// module chunks = 1